import { render, staticRenderFns } from "./PensionProvider.vue?vue&type=template&id=1526b572"
import script from "./PensionProvider.vue?vue&type=script&lang=js"
export * from "./PensionProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports